import BaseModel from './BaseModel'
import Location from './Location'

export default class Blackout extends BaseModel {

  static entity = 'blackouts'
  static primaryKey = 'ID'

  declare ID: number
  declare name: string
  declare locationID: number
  declare startDate: string
  declare endDate: string
  declare scope: string
  declare timezone: string
  declare status: string
  declare channels: string[]
  declare createdDate: string
  declare updatedDate: string
  declare deletedDate: string
  declare location: Location

  static fields() {

    return {

      // fields
      ID: this.number(null),
      name: this.string(''),
      locationID: this.number(null),
      startDate: this.string(''),
      endDate: this.string(''),
      scope: this.string('all'),
      timezone: this.string(''),
      status: this.string(''),
      channels: this.attr([]),
      createdDate: this.string(''),
      updatedDate: this.string(''),
      deletedDate: this.string(''),

      // relationships
      location: this.belongsTo(Location, 'locationID'),

    }

  }

  /**
   * API methods
   */

  static fetchAll() {
    return this.api().get('/blackouts', {
      dataKey: 'blackouts',
      dataTransformer: ({ data }) => {
        // ignore blackouts scopes other than "all"
        return data.blackouts.filter((blackout: any) => {
          return blackout.scope === 'all'
        });
      },
    })
  }

  /**
   * @deprecated Call saveNew() or saveExisting() directly instead.
   */
  static save(payload: any, isSaved: boolean) {
    if (isSaved) {
      return Blackout.saveExisting(payload)
    } else {
      return Blackout.saveNew(payload)
    }
  }

  static saveNew(payload: any) {
    return this.api().post('/blackouts', payload)
  }

  static saveExisting(payload: any) {
    return this.api().put('/blackouts/' + payload.ID, payload)
  }

  static destroy(blackoutID: number) {
    return this.api().delete('/blackouts/' + blackoutID, {
      delete: blackoutID,
    })
  }

}
